import { createContext, useEffect, useReducer } from "react";
import authInitialState from "./initialStates/authInitialState";
import configInitialState from "./initialStates/configInitialState";
import modalInitialState from "./initialStates/modalInitialState";
import modalAlertaInitialState from "./initialStates/modalAlertaInitialState";
import modeInitialState from "./initialStates/modeInitialState";
import toasterInitialState from "./initialStates/toasterInitialState";
import versionPublicadaInitialState from "./initialStates/versionInitialState";

import auth from "./reducers/auth";
import config from "./reducers/config";
import modal from "./reducers/modal";
import modalAlerta from "./reducers/modalAlerta";
import mode from "./reducers/mode";
import toaster from "./reducers/toaster";
import versionPublicada from "./reducers/versionPublicada";
import { RESET_GLOBAL_CONTEXT } from "./ActionTypes";

export const GlobalContext = createContext();

const GlobalProvider = ({ children }) => {
  const [authState, authDispatch] = useReducer(auth, [], () => {
    const localData = sessionStorage.auth;
    return localData ? JSON.parse(localData) : authInitialState;
  });

  useEffect(() => {
    try {
      const paciente = authState?.auth?.data?.paciente;
      const authToSave = paciente?.imagenPerfil
        ? {
            ...authState,
            auth: {
              ...authState.auth,
              data: {
                ...authState.auth.data,
                paciente: { ...paciente, imagenPerfil: undefined },
              },
            },
          }
        : authState;
      sessionStorage.auth = JSON.stringify(authToSave);
    } catch (e) {
      console.error("Error guardando auth en sessionStorage", e);
    }
  }, [authState]);

  // useEffect(() => {
  //   if (authState) {
  //     debugger
  //     // Creamos un objeto pequeño solo con lo necesario
  //     const minimalAuth = {
  //       isLoggedIn: authState.isLoggedIn,
  //       token: authState.token,
  //       user: {
  //         id: authState.user?.id,
  //         name: authState.user?.name
  //       }
  //     };
  
  //     try {
  //       sessionStorage.setItem('auth', JSON.stringify(minimalAuth));
  //     } catch (error) {
  //       console.error("Error: El almacenamiento está lleno", error);
  //     }
  //   }
  // }, [authState]);


  const [modeState, modeDispatch] = useReducer(mode, modeInitialState);
  const [toasterState, toasterDispatch] = useReducer(
    toaster,
    toasterInitialState
  );
  const [configState, configDispatch] = useReducer(config, configInitialState);
  const [modalState, modalDispatch] = useReducer(modal, modalInitialState);
  const [modalAlertaState, modalAlertaDispatch] = useReducer(
    modalAlerta,
    modalAlertaInitialState
  );
  const [versionPublicadaState, versionPublicadaDispatch] = useReducer(
    versionPublicada,
    versionPublicadaInitialState
  );

  //RESET GLOBAL CONTEXT
  const arrayDispatch = [
    authDispatch,
    toasterDispatch,
    modalDispatch,
    modalAlertaDispatch,
  ];

  const resetGlobalContext = (index) => {
    // Resetear los reducers no alcanza para desloguear: isAuthenticated() lee
    // sessionStorage.token, y si queda vivo el logout es cosmetico — las rutas
    // protegidas siguen abiertas y el webchat nunca recibe webchat:reset-session
    // (en una PC compartida el proximo usuario chatea como el paciente anterior).
    // Mismo trio que limpia logoutApp.js. Solo en la primera pasada (recursiva).
    if (index === 0) {
      sessionStorage.removeItem("token");
      sessionStorage.removeItem("refreshToken");
      sessionStorage.removeItem("auth");
    }
    if (Array.isArray(arrayDispatch)) {
      if (index >= arrayDispatch.length) {
        return;
      }
      const dispatch = arrayDispatch[index];
      dispatch({ type: RESET_GLOBAL_CONTEXT });
      resetGlobalContext(index + 1);
    }
  };

  return (
    <GlobalContext.Provider
      value={{
        authState,
        authDispatch,
        modeState,
        modeDispatch,
        toasterState,
        toasterDispatch,
        configState,
        configDispatch,
        modalState,
        modalDispatch,
        modalAlertaState,
        modalAlertaDispatch,
        versionPublicadaState,
        versionPublicadaDispatch,
        resetGlobalContext,
      }}
    >
      {children}
    </GlobalContext.Provider>
  );
};
export default GlobalProvider;
